import { connect } from 'react-redux';
import { showModal } from '@chegg-tutors-chat/shared/redux/modules/modals/actions';
import MessageAttachment, { MessageAttachmentDispatchProps } from './MessageAttachment';

export const mapDispatchToProps: MessageAttachmentDispatchProps = {
  showModal
};

export default connect(null, mapDispatchToProps)(MessageAttachment);
